import { observer } from "mobx-react-lite";
import Layout from "../../components/layout/Layout";
import {
  Button,
  DatePicker,
  Flex,
  Form,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Select,
  Spin,
  Table,
  Tabs,
  message,
  Radio,
  Image,
  Tooltip
} from "antd";
import {
  SaveOutlined,
  DownOutlined,
  UpOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DateSort, TextSort } from "../../helpers/SorterHelper";
import { useStore } from "../../stores/root-store-context";
import dayjs, { Dayjs } from "dayjs";
import { Option } from "antd/lib/mentions";
import TabPane from "antd/lib/tabs/TabPane";
import { useForm } from "antd/es/form/Form";
import { useNavigate, Link } from "react-router-dom";
import SalaryStore from "../../stores/SalaryStore";
import { getUserComponent } from "../../helpers/user";
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { TimeReport } from "../../api/TimeReportsApiClient";
import duration from 'dayjs/plugin/duration';
import { Salary } from "../../api/SalaryApiClient";
import utc from 'dayjs/plugin/utc';
import { formatMoney } from '../../helpers/formatMoney';
import { getDateLocale } from '../../helpers/dateLocalization';
import { Employee } from "../../models/Employee";

dayjs.extend(utc);
dayjs.extend(duration);

const { RangePicker } = DatePicker;

type SalariesItem = {
  id: any;
  userId: string;
  userEmail: string;
  salaryPerHour: string;
  salaryPerPeriod: string;
  hoursPerPeriod: string;
}


type SalariesItemString = {
  id: string;
  salaryPerHour: string;
  salaryPerMonth?: string;
  startDate: Dayjs;
  endDate: Dayjs;
  userId: string;
}

const SalariesPage = observer(() => {
  const [addForm] = useForm();
  const { applicationStore, employeesStore, timeReportStore, salaryStore, taskStore } = useStore();
  const { t, i18n } = useTranslation();
  const dateLocale = getDateLocale(i18n.language);
  const [startDate, setStartDate] = useState<Dayjs>(dayjs().utc().startOf("month"));
  const [endDate, setEndDate] = useState<Dayjs>(dayjs().utc().endOf("month"));
  const [isUpdating, setIsUpdating] = useState(false);
  const [isNewSalart, setIsNewSalart] = useState(true);
  const [salaries, setSalaries] = useState<SalariesItem[]>([]);
  const [salaryToAdd, setSalaryToAdd] = useState<any>({});
  const [users, setUsers] = useState<Employee[]>([]);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);
  const [currentSalaries, setCurrentSalaries] = useState<SalariesItemString[]>([]);
  const [salaryType, setSalaryType] = useState<'hour' | 'month'>('hour');
  const navigator = useNavigate();
  const [activeTabKey, setActiveTabKey] = useState("1");
  const location = useLocation();
  const [isExporting, setIsExporting] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  const currency = applicationStore.company?.Currency;

  const filterAndSortItems = (items: any[], startDate: Dayjs, endDate: Dayjs) => {

    const filteredItems = items.filter(item => endDate.isAfter(item.startDate));
    console.log("endDate", endDate);
    console.log("filteredItems", filteredItems);


    const futureItems = filteredItems.sort((a, b) => a.startDate.isBefore(b.startDate) ? 1 : -1);


    return [...futureItems, ...filteredItems];
  }

  const findValidElement = (data: any[]) => {
    console.log("data", data);

    const validElement = data.find(item => {
      return item.endTime?.format("YYYY-MM-DD") >= startDate.format("YYYY-MM-DD") && item.endTime?.format("YYYY-MM-DD") <= endDate.format("YYYY-MM-DD");
    });

    if (validElement) {
      return validElement;
    } else {
      const fallbackElement = data.reduce((closest, item) => {
        if (item.startDate.isBefore(startDate) && (!closest || item.startDate.isAfter(closest.startDate))) {
          return item;
        }
        return closest;
      }, null);
      return fallbackElement ? fallbackElement : null;
    }
  }

  const fetchSalaries = async () => {
    setIsUpdating(true);
    employeesStore.setLoading(true);
    await employeesStore.getUsers();
    const users = employeesStore.allUsers;
    console.log("users", JSON.parse(JSON.stringify(users)));
    const timeReports = await timeReportStore.getForFinancier(true);
    const resultSalay = await salaryStore.getByPeriod(startDate, endDate);

    const userSalaryList = users.map((user) => {

      const userSalaryArray = resultSalay.filter(
        (salary: any) => salary.userId.toString() === user.id.toString()
      );
      const filteredSalary = filterAndSortItems(userSalaryArray, startDate, endDate)
      console.log("user", user.id + " a");
      console.log("userSalaryArray", userSalaryArray);
      console.log("filteredSalary", filteredSalary);
      console.log("timeReports", JSON.parse(JSON.stringify(timeReports)));

      const userSalary = filteredSalary[0];
      let salaryPerPeriod = 0;
      let hoursPerPeriod = 0;
      const usersReports: { log: TimeReport, payment: number }[] = timeReports.filter(
        (report: { log: TimeReport, payment: number }) => report.log.userId === user.id &&
          report.log.endTime?.format("YYYY-MM-DD") >= startDate.format("YYYY-MM-DD") && report.log.endTime?.isBefore(endDate, "day")
      );

      usersReports.forEach((element) => {
        if (element?.log?.totalTime) {
          const [hours, minutes, seconds] = element?.log?.totalTime
            .split(":")
            .map(Number);
          hoursPerPeriod += hours + minutes / 60 + seconds / 3600;

          salaryPerPeriod = salaryPerPeriod + element.payment;
        }
      });
      if (user.isActive == false && salaryPerPeriod === 0) {
        return;
      }
      return {
        ...userSalary,
        id: userSalary?.id,
        userId: user.id,
        userEmail: user.email,
        salaryPerHour: userSalary ? userSalary.salaryPerHour : t("NoSalaryData"),
        salaryPerPeriod: salaryPerPeriod?.toFixed(2) || 0,
        hoursPerPeriod: hoursPerPeriod?.toFixed(2) || 0,
      };
    }).filter(el => el !== undefined);
    console.log("userSalaryList", userSalaryList);
    setSalaries(userSalaryList);
    setUsers(users);
    setIsUpdating(false);
  };

  const exportSalariesToExcel = async () => {
    setIsExporting(true);
    const formattedStartDate = startDate.format("YYYY-MM-DD");
    const formattedEndDate = endDate.format("YYYY-MM-DD");

    try {
      const success = await salaryStore.exportToExcel(formattedStartDate, formattedEndDate);
      if (success) {
        console.log(t("Export successful"));
      } else {
        console.error(t("Export failed"));
      }
    } catch (error) {
      console.error(t("An error occurred during export"), error);
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    fetchSalaries();
  }, [startDate, endDate]);

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash === "salaryRecords") {
      setActiveTabKey("2");
    } else {
      setActiveTabKey("1");
    }
  }, [location]);

  useEffect(() => {
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  const handleSalaryTypeChange = (e: any) => {
    const newSalaryType = e.target.value as 'hour' | 'month';
    setSalaryType(newSalaryType);

    console.log(`Salary type changed to: ${newSalaryType}`);

    if (newSalaryType === 'hour') {
      const calculatedSalaryPerHour = salaryToAdd.salaryPerMonth ? (salaryToAdd.salaryPerMonth / 160).toFixed(2) : undefined;
      console.log(`Calculated Salary Per Hour based on Salary Per Month: ${calculatedSalaryPerHour}`);
      addForm.setFieldsValue({
        salaryPerHour: calculatedSalaryPerHour
      });
      setSalaryToAdd((prev: any) => ({
        ...prev,
        salaryPerHour: calculatedSalaryPerHour,
      }));
    } else {
      const calculatedSalaryPerMonth = salaryToAdd.salaryPerHour ? (salaryToAdd.salaryPerHour * 160).toFixed(2) : undefined;
      console.log(`Calculated Salary Per Month based on Salary Per Hour: ${calculatedSalaryPerMonth}`);
      addForm.setFieldsValue({
        salaryPerMonth: calculatedSalaryPerMonth
      });
      setSalaryToAdd((prev: any) => ({
        ...prev,
        salaryPerMonth: calculatedSalaryPerMonth,
      }));
    }
  };

  const completeReviewTask = async (financierId: number, userEmail: string) => {
    try {
      await taskStore.fetchTasksByUserId(financierId.toString());

      const task = taskStore.tasks.find(t => t.title.includes(userEmail));

      if (!task) {
        // message.error("Task not found");
        return;
      }

      const success = await taskStore.ApiStore.TasksApiClient.markTaskAsCompleted(task.id);

      if (success) {
        message.success("Task marked as completed");
      } else {
        message.error("Failed to complete the task");
      }
    } catch (error) {
      message.error("Error occurred while completing the task");
      console.error(error);
    }
  };

  const fetchSalaryRecords = async () => {
    await salaryStore.getAll();
    const salaryRecords = salaryStore.salaries.map((salary: any) => ({
      ...salary,
      salaryPerHour: Number(salary.salaryPerHour).toFixed(4) + ` ${currency}`,
      salaryPerMonth: (salary.salaryPerHour ? (salary.salaryPerHour * 160).toFixed(4) : '0.0000') + ` ${currency}`,
    }));
    setCurrentSalaries(salaryRecords);
  };

  useEffect(() => {
    fetchSalaries();
  }, [startDate, endDate]);

  useEffect(() => {
    fetchSalaryRecords();
  }, []);

  const addSalary = async () => {
    message.open({
      type: "loading",
      content: t("Saving"),
      key: "saving",
    });

    const startDateFormatted = dayjs(salaryToAdd.startDate).startOf("day").format("YYYY-MM-DD");
    const plannedReviewDateFormatted = dayjs(salaryToAdd.plannedReviewDate).startOf("day").format("YYYY-MM-DD");

    salaryToAdd.startDate = startDateFormatted;
    salaryToAdd.endDate = plannedReviewDateFormatted;
    console.log("salaryToAdd");
    console.log(salaryToAdd);


    const result = await salaryStore.add(salaryToAdd);
    message.destroy("saving");
    console.log("result", result);

    if (result) {
      message.success(t("Success"));
      fetchSalaries();
      fetchSalaryRecords();

      const financierId = Number(applicationStore.user.id);
      const userEmail = salaryToAdd.userEmail;
      addForm.resetFields();
      setSalaryToAdd({});
      setSalaryType("hour");
      if (userEmail) {
        await completeReviewTask(financierId, userEmail);
        await taskStore.fetchTasksByUserId(applicationStore.user.id);
        applicationStore.initUserTasks();
      } else {
        console.error("User Email is undefined");
      }
    } else {
      message.error(result);
    }
    setUpdateModalVisible(false);
  };

  const updateSalary = async () => {
    message.open({
      type: "loading",
      content: t("Saving"),
      key: "saving",
    });

    const startDateFormatted = dayjs(salaryToAdd.startDate).startOf("day").format("YYYY-MM-DD");
    const plannedReviewDateFormatted = dayjs(salaryToAdd.plannedReviewDate).startOf("day").format("YYYY-MM-DD");
    console.log("salaryToAdd");
    console.log(startDateFormatted.toString());

    salaryToAdd.startDate = startDateFormatted;
    salaryToAdd.endDate = plannedReviewDateFormatted;

    const result = await salaryStore.ApiStore.SalaryApiClient.updateSalary(
      salaryToAdd.id,
      salaryToAdd
    );
    message.destroy("saving");

    if (result) {
      message.success(t("Success"));
      addForm.resetFields();
      setSalaryToAdd({});
      setSalaryType("hour");
      setUpdateModalVisible(false);
      fetchSalaries();
      fetchSalaryRecords();
      const financierId = Number(applicationStore.user.id);
      const userEmail = salaryToAdd.userEmail;

      if (userEmail) {
        await completeReviewTask(financierId, userEmail);
        await taskStore.fetchTasksByUserId(applicationStore.user.id);
        applicationStore.initUserTasks();
      } else {
        console.error("User Email is undefined");
      }
    } else {
      console.log("result");
      console.log(result);

      message.error(result);
    }
    message.destroy("saving");


    setUpdateModalVisible(false);
  };

  const deleteSalary = async (salaryId: string) => {
    message.open({
      type: "loading",
      content: t("Saving"),
      key: "saving",
    });
    const result = await employeesStore.ApiStore.SalaryApiClient.deleteSalary(
      salaryId
    );
    message.destroy("saving");
    if (result) {
      message.success(t("Success"));
      fetchSalaries();
      fetchSalaryRecords();
      await taskStore.fetchTasksByUserId(applicationStore.user.id);
      applicationStore.initUserTasks();
    } else {
      message.error(t("Error"));
    }
  };

  const handleUpdateClick = (record: any) => {
    setUpdateModalVisible(true);
    setIsNewSalart(false);

    const salary = salaryStore.salaries.find(s => s.id === record.id);
    const salaryPerHour = Number(salary?.salaryPerHour || 0);
    const salaryPerMonth = salaryPerHour * 160;

    addForm.setFieldsValue({
      salaryPerHour: salaryPerHour.toFixed(4),
      salaryPerMonth: salaryPerMonth.toFixed(4),
      startDate: dayjs(record.startDate),
      plannedReviewDate: dayjs(record.endDate),
      user: record.userId,
    });

    setSalaryToAdd({
      ...record,
      salaryPerHour: salaryPerHour.toFixed(4),
      salaryPerMonth: salaryPerMonth.toFixed(4),
    });
  };

  const handleAddClick = async (value: any) => {
    setIsUpdating(false);
    addForm.resetFields();
    setUpdateModalVisible(true);
    console.log(value);
  };

  useEffect(() => {
    if (isUpdating) {
      addForm.resetFields();
      addForm.setFieldsValue({
        salaryPerHour: salaryToAdd.salaryPerHour,
        salaryPerMonth: salaryToAdd.salaryPerHour * 160,
        userId: salaryToAdd.userId,
      });
    }
  }, [updateModalVisible, addForm, salaryToAdd]);

  useEffect(() => {
    setSalaryType("hour");
  }, [updateModalVisible]);

  const handleReviewSalaryClick = (record: any) => {
    setIsNewSalart(true);
    const user = users?.find((u: any) => u.id === record.userId);
    const items = currentSalaries.filter(salary => salary.userId == record.userId).sort((a, b) => DateSort(a.endDate, b.endDate));
    let lastItem = null;
    if (items.length > 0) {
      lastItem = items[items.length - 1];
    }
    const salaryData = {
      userId: record.userId,
      userEmail: user ? user.email : undefined,
      salaryPerHour: parseFloat(record.salaryPerHour),
      startDate: dayjs(record.endDate).add(1, 'day'),
      endDate: dayjs(record.endDate).add(3, 'month'),
      plannedReviewDate: dayjs(record.endDate).add(3, 'month'),
    };
    console.log("salaryData:", salaryData);
    console.log("record:", record);
    setSalaryToAdd({
      ...salaryData, salaryPerHour: isNaN(parseFloat(record.salaryPerHour))
        ? 0
        : parseFloat(record.salaryPerHour)
    });

    addForm.setFieldsValue({
      salaryPerHour: isNaN(parseFloat(record.salaryPerHour))
        ? 0
        : parseFloat(record.salaryPerHour),
      startDate: dayjs(record.endDate).add(1, 'day'),
      plannedReviewDate: salaryData.plannedReviewDate,
      user: record.userId,
    });

    setUpdateModalVisible(true);
  };

  const columns = [
    {
      title: t("Employee"),
      dataIndex: "userEmail",
      key: "userEmail",
      filters: users?.map((user: any) => ({
        text: user.email,
        value: user.email,
      })),
      onFilter: (value: any, record: any) => record.userEmail.includes(value),
      sorter: (a: any, b: any) => TextSort(a.userEmail, b.userEmail),
      render: (text: string, record: any) => {
        const user = users?.find((u) => u.email === text);

        return (
          <Flex align="center">
            <Image
              width={80}
              height={80}
              style={{ borderRadius: "50%", objectFit: "cover" }}
              src={
                user?.photoId
                  ? `${applicationStore?.siteConfig?.baseCloudinary}/image/upload/w_300/${user.photoId}`
                  : `https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/z03w7hlsy8hcoic9dlcn`
              }
              alt={user?.firstName}
            />
            <div style={{ marginLeft: 20 }}>
              <Link
                to={`/${applicationStore.company.Tenant}/employees/${user?.id}`}
                style={{ display: "block" }}
              >
                {`${user?.firstName} ${user?.lastName}`}
              </Link>
              <div style={{ color: "gray" }}>{user?.email}</div>
            </div>
          </Flex>
        );
      },
    },
    Table.EXPAND_COLUMN,
    {
      title: t("HourlyRate"),
      dataIndex: "salaryPerHour",
      filters: [
        { text: t("All"), value: "all" },
        { text: t("NoSalaryData"), value: t("NoSalaryData") },
      ],
      onFilter: (value: any, record: any) => {
        if (value === "all") return true;
        return record.salaryPerHour === t("NoSalaryData");
      },
      render: (salaryPerHour: number) => Number(salaryPerHour) ? formatMoney(Number(salaryPerHour), currency) : 0,
      sorter: (a: any, b: any) => a.salaryPerHour - b.salaryPerHour,
      key: "salaryPerHour",
    },
    {
      title: t("SalaryPayPeriod"),
      dataIndex: "salaryPerPeriod",
      render: (salaryPerPeriod: any) => formatMoney(Number(salaryPerPeriod), currency),
      sorter: (a: any, b: any) => a.salaryPerPeriod - b.salaryPerPeriod,
      key: "salaryPerPeriod",
    },
    {
      title: t("HoursWorked"),
      dataIndex: "hoursPerPeriod",
      render: (salaryPerPeriod: any) => `${salaryPerPeriod}`,
      sorter: (a: any, b: any) => parseFloat(a.salaryPerPeriod) - parseFloat(b.salaryPerPeriod),
      key: "hoursPerPeriod",
    },
    {
      title: t("Actions"),
      key: "actions",
      render: (text: any, record: any) => (
        <Flex gap={10}>
          <Button
            icon={<PlusCircleOutlined />}
            onClick={() => handleReviewSalaryClick(record)}
          >
            {t("ReviewSalary")}
          </Button>
        </Flex>
      ),
    }
  ];

  const currentSalariesColumns = [
    // {
    //   title: t("User"),
    //   dataIndex: "userId",
    //   key: "userId",
    //   render: (data: string) => <div>{getUserComponent(employeesStore.users.find(el => el.id === data), applicationStore.company?.Tenant)}</div>,
    // },
    {
      title: t("HourlyRate"),
      dataIndex: "salaryPerHour",
      key: "salaryPerHour",
    },
    {
      title: t("StartDate"),
      dataIndex: "startDate",
      key: "startDate",
      render: (date: string) => dayjs(date).format("YYYY.MM.DD"),
    },
    {
      title: t("ReviewDate"),
      dataIndex: "endDate",
      key: "endDate",
      render: (date: string) => dayjs(date).format("YYYY.MM.DD"),
    },
    {
      title: t("Actions"),
      key: "actions",
      render: (text: any, record: any) => (
        <Flex gap={10}>
          <Button
            icon={<EditOutlined />}
            // disabled={true}
            onClick={() => {
              handleUpdateClick(record);
            }}
          >
            {t("EditThisRecord")}
          </Button>
        </Flex>
      ),
    },
    {
      title: "",
      dataIndex: "operation",
      render: (_: any, record: any) => {
        return (
          <>
            <Flex justify="space-between">
              <Popconfirm
                title={t("DeleteSalary")}
                description={t("ConfirmDeleteSalary")}
                okText={t("Yes")}
                cancelText={t("No")}
                onConfirm={(e) => {
                  deleteSalary(record.id);
                }}
              >
                <Button
                  type="primary"
                  danger
                  shape="circle"
                  icon={<DeleteOutlined />}
                />
              </Popconfirm>
            </Flex>
          </>
        );
      },
    },
  ];

  return (
    <Layout headerStyle={1} footerStyle={2} breadcrumbTitle={t("Menu.Salaries")}>
      <div className="container" style={{ margin: "20px auto" }}>
        <Tabs defaultActiveKey="1" activeKey={activeTabKey} onChange={setActiveTabKey}>
          <TabPane tab={t("Menu.Salaries")} key="1">
            <Spin spinning={salaryStore.isLoading || isUpdating} style={{ minHeight: 600 }}>
              <Flex
                style={{ marginTop: "15px", justifyContent: "space-between" }}
                gap={5}
                align="baseline"
              >
                <Flex>
                  <Button
                    shape="circle"
                    onClick={(e) => {
                      const newStartDate = startDate.subtract(1, "month").startOf("month");
                      setStartDate(newStartDate);
                      setEndDate(newStartDate.endOf("month"));
                    }}
                  >
                    <LeftOutlined />
                  </Button>
                  <RangePicker
                    key={currentLanguage}
                    locale={dateLocale}
                    value={[startDate, endDate]}
                    picker="date"
                    format="DD MMMM YYYY"
                    style={{ marginBottom: 16 }}
                    onChange={(dates: any) => {
                      setStartDate(dates[0]);
                      setEndDate(dates[1]);
                    }}
                  />
                  <Button
                    shape="circle"
                    onClick={(e) => {
                      const newStartDate = startDate.add(1, "month").startOf("month");
                      setStartDate(newStartDate);
                      setEndDate(newStartDate.endOf("month"));
                    }}
                  >
                    <RightOutlined />
                  </Button>
                </Flex>
                <Button
                  onClick={exportSalariesToExcel}
                  style={{ marginLeft: "115px" }}
                >
                  {t("ExportSalaryToExcel")}
                </Button>
                <Button
                  onClick={(e) => handleAddClick(e)}
                  style={{ marginRight: "115px" }}
                >
                  {t("Add")}
                </Button>
              </Flex>
              <Table dataSource={salaries}
                columns={columns}
                pagination={{ pageSize: 20 }}
                rowKey="id"
                rowHoverable
                expandable={{
                  expandIcon: ({ expanded, onExpand, record }) => {
                    if (expanded) {
                      return (
                        <Button shape="circle" onClick={(e) => onExpand(record, e)}>
                          <UpOutlined />
                        </Button>
                      );
                    } else {
                      return (
                        <Button shape="circle" onClick={(e) => onExpand(record, e)}>
                          <DownOutlined />
                        </Button>
                      );
                    }
                  },
                  expandRowByClick: true,
                  expandedRowRender: (record, index) => {
                    const salaries = currentSalaries.filter(salary => salary.userId == record.userId).sort((a, b) => DateSort(a.endDate, b.endDate));
                    if (salaries.length === 0) {
                      return null;
                    }
                    return (
                      <Table
                        dataSource={salaries}
                        columns={currentSalariesColumns}
                        pagination={{ pageSize: 20 }}
                        rowKey="id"
                        key={"expandedRowRender-" + index}
                      />
                    );
                  },
                }}
              />

              <Modal
                key={currentLanguage}
                open={updateModalVisible}
                footer={null}
                width={600}
                onCancel={() => {
                  setUpdateModalVisible(false);
                  setSalaryType("hour");
                  addForm.resetFields();
                }}
                title={isNewSalart ? `${t("Add")}` : t("EditThisRecord")}
              >
                <Form
                  key={currentLanguage}
                  form={addForm}
                  onFinish={isNewSalart ? addSalary : updateSalary}
                  initialValues={{ salaryType: 'hour', }}
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 12 }}
                  labelAlign="left"
                  style={{ width: '580px' }}
                >
                  <Flex
                    style={{
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Form.Item
                      label={t("SalaryType")}
                      name="salaryType"
                      style={{ width: "100%" }}
                    >
                      <Radio.Group
                        onChange={handleSalaryTypeChange}
                        value={salaryType}
                        style={{ width: "100%", textAlign: "left" }}
                      >
                        <Radio.Button value="hour" style={{ width: "40%", textAlign: "center" }}>
                          {t("PerHour")}
                        </Radio.Button>
                        <Radio.Button value="month" style={{ width: "60%", textAlign: "center" }}>
                          {t("PerMonth160Hours")}
                        </Radio.Button>
                      </Radio.Group>
                    </Form.Item>

                    {salaryType === "hour" ? (
                      <Form.Item
                        label={`${t("HourlyRate")} (${currency})`}
                        name="salaryPerHour"
                        rules={[{ required: true }]}
                        style={{ width: "100%" }}
                      >
                        <InputNumber
                          min={0}
                          disabled={salaryType !== "hour"}
                          onChange={(value) => {
                            if (value !== null) {
                              const calculatedSalaryPerMonth = value ? ((value as number) * 160).toFixed(4) : 0;

                              addForm.setFieldsValue({
                                salaryPerMonth: calculatedSalaryPerMonth
                              });
                              setSalaryToAdd((prev: any) => ({
                                ...prev,
                                salaryPerHour: Number(value).toFixed(4),
                              }));
                            }
                          }}
                          style={{ width: "100%" }}
                          precision={4}
                        />
                      </Form.Item>
                    ) : (
                      <Form.Item
                        label={`${t("SalaryPerMonth")} (${currency})`}
                        name="salaryPerMonth"
                        rules={[{ required: true }]}
                        style={{ width: "100%" }}
                      >
                        <InputNumber
                          disabled={salaryType !== "month"}
                          onChange={(value) => {
                            if (value !== null) {
                              const calculatedSalaryPerHour = value ? ((value as number) / 160).toFixed(4) : undefined;
                              addForm.setFieldsValue({
                                salaryPerHour: calculatedSalaryPerHour
                              });
                              setSalaryToAdd((prev: any) => ({
                                ...prev,
                                salaryPerMonth: Number(value).toFixed(4),
                                salaryPerHour: calculatedSalaryPerHour,
                              }));
                            }
                          }}
                          style={{ width: "100%" }}
                          precision={4}
                        />
                      </Form.Item>
                    )}

                    <Form.Item
                      label={t("StartDate")}
                      name="startDate"
                      rules={[{ required: true, message: t("PleaseSelectAStartDate") }]}
                      style={{ width: "100%" }}
                    >
                      <DatePicker
                        key={currentLanguage}
                        locale={dateLocale}
                        style={{ width: "100%" }}
                        onChange={(date) => {
                          const localDate = date ? date.startOf("day").format("YYYY-MM-DD") : null;
                          const plannedReviewDate = date ? date.add(3, 'month') : null;
                          setSalaryToAdd({
                            ...salaryToAdd,
                            startDate: localDate,
                            plannedReviewDate: plannedReviewDate, // Automatically set planned review date
                          });
                          addForm.setFieldsValue({
                            plannedReviewDate: plannedReviewDate, // Update the planned review date field in the form
                          });
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      label={<span style={{ textWrap: "wrap", overflow: "visible", whiteSpace: "pre-wrap" }}>{t("ReviewDate")}</span>}
                      name="plannedReviewDate"
                      initialValue={dayjs().add(3, 'month')}
                      style={{ width: "100%" }}
                      rules={[{ required: true, message: t("PleaseSelectAReviewDate") }]}
                    >
                      <DatePicker
                        key={currentLanguage}
                        locale={dateLocale}
                        style={{ width: "100%" }}
                        onChange={(date) => {
                          setSalaryToAdd({ ...salaryToAdd, plannedReviewDate: date });
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      label={t("User")}
                      name="user"
                      style={{ width: "100%" }}
                      rules={[{ required: true, message: t("PleaseSelectAUser") }]}
                    >
                      <Select
                        onSelect={(e) => {
                          setSalaryToAdd({ ...salaryToAdd, userId: e })
                        }
                        }
                        value={salaryToAdd.userId}
                        showSearch={true}
                        filterOption={(input, option) => {
                          const label = typeof option?.label === "string" ? option.label : "";
                          return label.toLowerCase().includes(input.toLowerCase());
                        }}
                        style={{ width: "100%" }}
                        optionLabelProp="label"
                      >
                        {users?.slice()
                          .sort((a, b) => a.firstName.localeCompare(b.firstName, 'uk')).map((user) => (
                            <Select.Option
                              value={user.id}
                              key={user.id}
                              label={`${user.firstName} ${user.lastName}`}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  minWidth: 0, 
                                }}
                              >
                                <div
                                  style={{
                                    flexShrink: 0,
                                    marginRight: 12,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Image
                                    width={40}
                                    height={40}
                                    preview={false}
                                    style={{
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                    }}
                                    src={
                                      user.photoId
                                        ? `${applicationStore?.siteConfig?.baseCloudinary}/image/upload/w_300/${user.photoId}`
                                        : `https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/z03w7hlsy8hcoic9dlcn`
                                    }
                                    alt={user.firstName}
                                  />
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden",
                                    minWidth: 0,
                                  }}
                                >
                                  <Tooltip title={`${user.firstName} ${user.lastName}`}>
                                    <div
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: 200,
                                        fontWeight: 500,
                                        cursor: "default",
                                      }}
                                    >
                                      {user.firstName} {user.lastName}
                                    </div>
                                  </Tooltip>

                                  <Tooltip title={user.email}>
                                    <div
                                      style={{
                                        color: "gray",
                                        fontSize: 12,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: 200,
                                        cursor: "default",
                                      }}
                                    >
                                      {user.email}
                                    </div>
                                  </Tooltip>
                                </div>
                              </div>
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item style={{ alignItems: "start" }}>
                      <Button
                        type="primary"
                        className="theme-btn"
                        htmlType="submit"
                        style={{ height: 70 }}
                      >
                        {`${t("Save")}`}{" "}
                        <SaveOutlined style={{ fontSize: 20, margin: 5 }} />
                      </Button>
                    </Form.Item>
                  </Flex>
                </Form>
              </Modal>
            </Spin>
          </TabPane>
          {/* <TabPane tab={t("Menu.SalaryRecords")} key="2">
            <Spin spinning={salaryStore.isLoading}>
              <Table
                dataSource={currentSalaries}
                columns={currentSalariesColumns}
                rowKey="id"
              />
            </Spin>
          </TabPane> */}
        </Tabs>
      </div>
    </Layout>
  );
});
export default SalariesPage;
